<template>
    <div class="w-full space-y-3">
        <slot name="title"></slot>
        <div class="flex justify-between">
            <div class="w-full flex gap-3 justify-between">
                <div class="w-full flex gap-3">
                    <InvoiceTabs/>
                </div>
            </div>
            <div class="w-full flex justify-end justify-content-end align-items-end">
                <slot name="searchfilter"></slot>
            </div>
        </div>
    </div>
    <div>
        <slot :key="$page.url"></slot>
    </div>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import InvoiceSearchFilter from "@/Components/InvoiceSearchFilter.vue";
import InvoiceTabs from "@/Components/InvoiceTabs";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import {Link, useForm} from "@inertiajs/vue3";
import CreateOrganisationGroup from "@/Components/SlideOuts/CreateOrganisationGroup";
import {mapActions} from "vuex";

export default {
    layout: Authenticated,
    components: {
        CreateOrganisationGroup,
        InvoiceSearchFilter,
        InvoiceTabs,
        Link
    },
    methods: {
        ...mapActions('organisations', [
            'openCreateGroup'
        ]),
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.$inertia.get(route('frontend.invoices.index'), pickBy(this.form), {preserveState: true})
            }, 500),
        },
    }
}
</script>
